import $ from 'jquery'

$(document).ready( initEventsHub )

function initEventsHub(){
    
  let ajaxurl = SITE.ajaxUrl;

  function load_event_posts(page, event_cat){
    $('#upcoming-posts-list').addClass('loading');
    $('#upcoming-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      page: page,
      event_cat: event_cat,
      action: "get_events_posts_ajax"
    };
    // Send the data
    $.post(ajaxurl, data, function(response) {
      // If successful Append the data into our html container
      if (response.length) {
        $("#upcoming-posts-list").html(response);
        setTimeout(() => {
          $('#upcoming-posts-list').removeClass('loading');
          $('#upcoming-pagination').show();
        }, "700");
      } else {
        $('#upcoming-pagination').hide();
        $("#upcoming-posts-list").html('<div class="resources__no-results"><img class="lazyload" data-src="/wp-content/themes/blend/img/noresults.svg" alt="binocolars" /><h4>No results meet the filtered criteria, please reset filter.</h4></div>');
        $('#upcoming-posts-list').removeClass('loading');
      }
    });
  }

  function load_event_pagination(event_cat){

    $('#upcoming-posts-list').addClass('loading');
    $('#upcoming-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      event_cat: event_cat,
      action: "get_events_posts_pagination"
    };

    // Send the data
    $.post(ajaxurl, data, function(response) {
      // If successful Append the data into our html container
      $('#upcoming-pagination').html(response);
      setTimeout(() => {
        $('#upcoming-posts-list').removeClass('loading');
        $('#upcoming-pagination').show(); 
      }, "700");
    });
  }


  // Handle the dropdown change
  $('#event-cat-select').on('change',function(){
    let $current_page = 1;
    let $event_cat = $(this).val();

    load_event_pagination($event_cat);
    load_event_posts($current_page, $event_cat);
  });

  // Handle the pagination clicks
  $('#upcoming-pagination').on('click', 'li', function(e){

    $('html, body').animate({
      scrollTop: $("#upcoming-posts-list").offset().top - 200
    }, 500);

    let $current_li = $('#upcoming-pagination li.current');

    if($(this).hasClass('prev') || $(this).hasClass('next')) {

      if($(this).css('opacity') == 0) {
        return false;
      }

      if($(this).hasClass('prev')) {

        $current_li.removeClass('current');
        $current_li.prev().addClass('current');
        $current_li = $('#upcoming-pagination li.current');


        $('#upcoming-pagination li:not(.prev, .next)').hide();
        $('#upcoming-pagination li.prev, #upcoming-pagination li.next').show();

        if($current_li.text() == '1') {
          $('#upcoming-pagination .prev').css('opacity', '0');
        } else {
          $('#upcoming-pagination .prev').css('opacity', '1');
        }

        $($current_li).show();
        if($current_li.text() != '1') {
          $($current_li.prev()).show();
        } else {
          $($current_li.next().next()).show();
        }
        $($current_li.next()).show();

      } else if($(this).hasClass('next')) {

        $current_li.removeClass('current');
        $current_li.next().addClass('current');
        $current_li = $('#upcoming-pagination li.current');
        $('#upcoming-pagination li:not(.prev, .next)').hide();
        $('#upcoming-pagination li.prev, #upcoming-pagination li.next').show();

        if($current_li.text() == $('#upcoming-pagination li:not(.prev, .next)').length) {
          $('#upcoming-pagination .next').css('opacity', '0');
        } else {
          $('#upcoming-pagination .next').css('opacity', '1');
        }

        $($current_li).show();
        $($current_li.prev()).show();
        if($current_li.text() != $('#upcoming-pagination li:not(.prev, .next)').length) {
          $($current_li.next()).show();
        } else {
          $($current_li.prev().prev()).show();
        }

        $($current_li.prev()).show();
      }

    } else {
      $('#upcoming-pagination li').removeClass('current');
      $(this).addClass('current');
      $current_li = $('#upcoming-pagination li.current');
      $('#upcoming-pagination li:not(.prev, .next)').hide();
      $current_li.show();
      if($current_li.text() != '1') {
        $($current_li.prev()).show();
      } else {
        $($current_li.next().next()).show();
      }

      if($current_li.text() != $('#upcoming-pagination li:not(.prev, .next)').length) {
        $($current_li.next()).show();
      } else {
        $($current_li.prev().prev()).show();
      }
    }

    $current_li = $('#upcoming-pagination li.current');
    let $current_page = $($current_li).text();
    let $event_cat = $('#event-cat-select').val();

    if($current_page == 1) {
      $('#upcoming-pagination li.prev').css('opacity', '0');
    } else {
      $('#upcoming-pagination li.prev').css('opacity', '1');
    }

    if($current_page == $('#upcoming-pagination li:not(.prev, .next)').length) {
      $('#upcoming-pagination li.next').css('opacity', '0');
    }  else {
      $('#upcoming-pagination li.next').css('opacity', '1');
    }

    load_event_posts($current_page, $event_cat);

  });

  function load_ondemand_posts(page) {
    $('#ondemand-posts-list').addClass('loading');
    $('#ondemand-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      page: page,
      action: "get_ondemand_posts_ajax"
    };
    // Send the data
    $.post(ajaxurl, data, function (response) {
      // If successful Append the data into our html container
      if (response.length) {
        $("#ondemand-posts-list").html(response);
        setTimeout(() => {
          $('#ondemand-posts-list').removeClass('loading');
          $('#ondemand-pagination').show();
        }, "700");
      } else {
        $('#ondemand-pagination').hide();
        $("#ondemand-posts-list").html('<div class="resources__no-results"><img class="lazyload" data-src="/wp-content/themes/blend/img/noresults.svg" alt="binocolars" /><h4>No results meet the filtered criteria, please reset filter.</h4></div>');
        $('#ondemand-posts-list').removeClass('loading');
      }
    });
  }

  function load_ondemand_pagination() {

    $('#ondemand-posts-list').addClass('loading');
    $('#ondemand-pagination').hide();

    // Data to receive from our server
    // the value in 'action' is the key that will be identified by the 'wp_ajax_' hook
    let data = {
      action: "get_ondemand_posts_pagination"
    };

    // Send the data
    $.post(ajaxurl, data, function (response) {
      // If successful Append the data into our html container
      $('#ondemand-pagination').html(response);
      setTimeout(() => {
        $('#ondemand-posts-list').removeClass('loading');
        $('#ondemand-pagination').show();
      }, "700");
    });
  }

  // Handle the pagination clicks
  $('#ondemand-pagination').on('click', 'li', function (e) {

    $('html, body').animate({
      scrollTop: $("#ondemand-posts-list").offset().top - 200
    }, 500);

    let $current_li = $('#ondemand-pagination li.current');

    if ($(this).hasClass('prev') || $(this).hasClass('next')) {

      if ($(this).css('opacity') == 0) {
        return false;
      }

      if ($(this).hasClass('prev')) {

        $current_li.removeClass('current');
        $current_li.prev().addClass('current');
        $current_li = $('#ondemand-pagination li.current');


        $('#ondemand-pagination li:not(.prev, .next)').hide();
        $('#ondemand-pagination li.prev, #ondemand-pagination li.next').show();

        if ($current_li.text() == '1') {
          $('#ondemand-pagination .prev').css('opacity', '0');
        } else {
          $('#ondemand-pagination .prev').css('opacity', '1');
        }

        $($current_li).show();
        if ($current_li.text() != '1') {
          $($current_li.prev()).show();
        } else {
          $($current_li.next().next()).show();
        }
        $($current_li.next()).show();

      } else if ($(this).hasClass('next')) {

        $current_li.removeClass('current');
        $current_li.next().addClass('current');
        $current_li = $('#ondemand-pagination li.current');
        $('#ondemand-pagination li:not(.prev, .next)').hide();
        $('#ondemand-pagination li.prev, #ondemand-pagination li.next').show();

        if ($current_li.text() == $('#ondemand-pagination li:not(.prev, .next)').length) {
          $('#ondemand-pagination .next').css('opacity', '0');
        } else {
          $('#ondemand-pagination .next').css('opacity', '1');
        }

        $($current_li).show();
        $($current_li.prev()).show();
        if ($current_li.text() != $('#ondemand-pagination li:not(.prev, .next)').length) {
          $($current_li.next()).show();
        } else {
          $($current_li.prev().prev()).show();
        }

        $($current_li.prev()).show();
      }

    } else {
      $('#ondemand-pagination li').removeClass('current');
      $(this).addClass('current');
      $current_li = $('#ondemand-pagination li.current');
      $('#ondemand-pagination li:not(.prev, .next)').hide();
      $current_li.show();
      if ($current_li.text() != '1') {
        $($current_li.prev()).show();
      } else {
        $($current_li.next().next()).show();
      }

      if ($current_li.text() != $('#ondemand-pagination li:not(.prev, .next)').length) {
        $($current_li.next()).show();
      } else {
        $($current_li.prev().prev()).show();
      }
    }

    $current_li = $('#ondemand-pagination li.current');
    let $current_page = $($current_li).text();

    if ($current_page == 1) {
      $('#ondemand-pagination li.prev').css('opacity', '0');
    } else {
      $('#ondemand-pagination li.prev').css('opacity', '1');
    }

    if ($current_page == $('#ondemand-pagination li:not(.prev, .next)').length) {
      $('#ondemand-pagination li.next').css('opacity', '0');
    } else {
      $('#ondemand-pagination li.next').css('opacity', '1');
    }

    load_ondemand_posts($current_page);

  });
}
